import { motion } from "framer-motion";
import Reveal from "../components/Reveal";
import { TIMELINE } from "../data/content";

export default function Timeline() {
  return (
    <section data-testid="timeline-section" className="relative bg-[#070707]">
      <div className="container-x section-y">
        <Reveal>
          <span className="overline">Our Journey</span>
          <h2 className="mt-4 font-playfair text-3xl font-bold tracking-tight sm:text-4xl lg:text-5xl">
            Milestones
          </h2>
        </Reveal>

        <div className="mt-12 grid grid-cols-2 gap-4 md:grid-cols-3 lg:grid-cols-6">
          {TIMELINE.map((m, i) => (
            <Reveal key={i} delay={i * 0.05}>
              <div className="group">
                <div className="relative aspect-[3/4] overflow-hidden">
                  <img src={m.image} alt={m.title} loading="lazy" className="h-full w-full object-cover brightness-75 transition-all duration-700 group-hover:scale-105 group-hover:brightness-100" />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/70 to-transparent" />
                  <span className="absolute left-3 top-3 font-playfair text-2xl font-bold text-gold">{m.year}</span>
                </div>
                <h3 className="mt-3 font-playfair text-lg text-white">{m.title}</h3>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
